import { useState, useRef } from 'react';
import QRCode from 'react-qr-code';
import { Download } from 'lucide-react';

export default function QRCodeDemo() {
  const [url, setUrl] = useState('https://museo-test.local/example');
  const qrCodeRef = useRef<HTMLDivElement>(null);

  function downloadQRCode() {
    if (qrCodeRef.current) {
      const canvas = qrCodeRef.current.querySelector('canvas');
      if (canvas) {
        const link = document.createElement('a');
        link.href = canvas.toDataURL('image/png');
        link.download = `qr-code-${Date.now()}.png`;
        link.click();
      }
    }
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 to-slate-800 p-8">
      <div className="max-w-2xl mx-auto">
        <div className="bg-white rounded-2xl shadow-2xl p-8 space-y-6">
          <div>
            <h1 className="text-3xl font-bold text-gray-900 mb-2">QR Code Generator</h1>
            <p className="text-gray-600">Inserisci un URL per generare il codice QR corrispondente</p>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              URL
            </label>
            <input
              type="url"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
              placeholder="https://example.com"
              className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:outline-none focus:border-indigo-500 transition-colors"
            />
          </div>

          {url && (
            <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 bg-gray-50">
              <div className="flex flex-col items-center space-y-4">
                <div className="flex justify-center p-4 bg-white rounded border-2 border-gray-200">
                  <div ref={qrCodeRef}>
                    <QRCode
                      value={url}
                      size={300}
                      level="H"
                    />
                  </div>
                </div>

                <button
                  onClick={downloadQRCode}
                  className="flex items-center gap-2 bg-indigo-600 text-white px-6 py-3 rounded-lg hover:bg-indigo-700 transition-colors font-medium"
                >
                  <Download size={18} />
                  Scarica QR Code
                </button>

                <div className="w-full">
                  <p className="text-sm text-gray-600 mb-2">URL codificato:</p>
                  <div className="bg-white p-3 rounded border border-gray-200 break-all text-sm font-mono text-gray-700">
                    {url}
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
            <p className="text-sm text-blue-800">
              <strong>💡 Tip:</strong> Questo QR code è stato integrato anche nel modulo di gestione delle attrazioni (POI).
              Quando aggiungi o modifichi un'attrazione, puoi inserire un URL e ottenere un'anteprima del QR code generato.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
